import { render, staticRenderFns } from "./AttachSerial.vue?vue&type=template&id=3feb4fd0&scoped=true"
import script from "./AttachSerial.vue?vue&type=script&lang=js"
export * from "./AttachSerial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3feb4fd0",
  null
  
)

export default component.exports